import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { Icon, Button, Hr } from 'LocalGluons';
import styles from './DeleteConfirmDialog.jss';

const buttonStyle = { button: styles.button };

const DeleteConfirmDialog = ({ onDeleteConfirm, close }) => (
    <View style={styles.window}>
        <Icon style={styles.closeIcon} name="close" onPress={close} testID="close_button" />
        <Text style={styles.title}>{t('DOWNLOADS.DELETE_DIALOG_TITLE')}</Text>
        <Hr />
        <Text style={styles.greyText}>{t('DOWNLOADS.DELETE_DIALOG_TEXT')}</Text>
        <View style={styles.buttonContainer}>
            <Button
                style={buttonStyle}
                title={t('DOWNLOADS.TO_CANCEL')}
                onPress={close}
                isSecondary
                testID="cancel_button"
            />
            <Button
                style={buttonStyle}
                title={t('COMMON.DELETE')}
                onPress={onDeleteConfirm}
                testID="delete_button"
            />
        </View>
    </View>
);

DeleteConfirmDialog.propTypes = {
    onDeleteConfirm: PropTypes.func.isRequired,
    close: PropTypes.func.isRequired
};

export default DeleteConfirmDialog;
